import { PREVENT_SCROLLING } from "../constants";

function isActive() {
    return document.body.classList.contains(PREVENT_SCROLLING);
}
function start() {
    if (!isActive()) {
        document.body.classList.add(PREVENT_SCROLLING);
    }
}
function stop() {
    if (isActive()) {
        document.body.classList.remove(PREVENT_SCROLLING);
    }
}

export default {
    start,
    stop,
};
